module.exports = __webpack_public_path__ + "static/media/match.fef4c1cc.webp";